export type LinkHeader = {
  next?: string
  last?: string
  first?: string
  prev?: string
}

export const parseLinkHeader = (header: string | null): LinkHeader | undefined => {
  if (!header || header.length === 0) {
    return undefined
  }
  
  // Split parts by comma
  const parts = header.split(',')
  const linkHeader = {}
  
  // Parse each part into a named link
  parts.forEach(p => {
    const section = p.split(';')
    
    if (section.length !== 2) {
      throw new Error('section could not be split on \';\'')
    }
  
    const url = section[0].replace(/<(.*)>/, '$1').trim()
    const relName = section[1].replace(/rel="(.*)"/, '$1').trim()
    const name = relName.split('=')[1]
    linkHeader[name] = url
  })
  
  return linkHeader
}